import { Navigate } from 'react-router-dom';
import { paths } from 'core/routing/paths';

/** Legacy route — company-code entry lives on /assessment/intro. */
export function CompanyCodePage() {
  return <Navigate to={paths.assessmentIntro} replace />;
}
